export default __webpack_public_path__ + "static/media/web-programming.c12c8bcf.png";